import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/headerExpanded.js';
// import s from 'components/bolt/header/headerExpanded.sss';

export default class HeaderExpanded extends BaseComp.default {

	renderSocial() {
		const isDesktopWidth = this.props?.client?.isDesktopWidth;
		if (isDesktopWidth) {
			return;
		}
		return super.renderSocial();
	}

}
